import { StyledCol, StyledInput, StyledTitle } from '@/shared/styles';
import { RequiredFieldGroupProps } from './Framework.consts';
import { StyledRequiredFieldGroup } from './Framework.styles';
import { RequiredField } from './RequiredField';
import { StyledLabel } from '../Forms/Forms.styles';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLangStore } from '@/stores/LangStore/LangStore';

export const RequiredFieldGroup: React.FC<RequiredFieldGroupProps> = ({
  frameworkCode,
  frameworkTitle,
  fields,
}: RequiredFieldGroupProps) => {
  const { t } = useTranslation();
  const isRtl = useLangStore((state) => state.isRtl());

  return (
    <StyledRequiredFieldGroup key={frameworkCode}>
      <StyledTitle $size={18} $width={'100%'} style={{ textAlign: isRtl ? 'left' : 'right' }}>
        {frameworkTitle}
      </StyledTitle>
      {fields.map((field) => (
        <RequiredField key={field.name} frameworkCode={frameworkCode} field={field} />
      ))}
      <StyledCol $gap={8}>
        <StyledLabel>
          {t('projects.new_project.form.name.text')} ({t('optional')})
        </StyledLabel>
        <Form.Item name={['frameworksSettings', frameworkCode, 'projectName']}>
          <StyledInput placeholder={t('admin.table.name')} />
        </Form.Item>
      </StyledCol>
    </StyledRequiredFieldGroup>
  );
};
